import { render, staticRenderFns } from "./ChangeTempPassword.vue?vue&type=template&id=494080ef"
import script from "./ChangeTempPassword.vue?vue&type=script&lang=js"
export * from "./ChangeTempPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports